import { render, staticRenderFns } from "./V2AppFooter.vue?vue&type=template&id=aba15d16&scoped=true&"
import script from "./V2AppFooter.vue?vue&type=script&lang=js&"
export * from "./V2AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./V2AppFooter.vue?vue&type=style&index=0&id=aba15d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba15d16",
  null
  
)

export default component.exports